import { EsitoComponent } from './components/esito/esito.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagamentoComponent } from './components/pagamento/pagamento.component';

const routes: Routes = [
  {
    path: 'public',
    children: [
      { path: 'pagamento', pathMatch: 'full', component : PagamentoComponent},
      { path: 'riepilogo-pagamento', component : PagamentoComponent},
      { path: 'esito-pagamento', component: EsitoComponent }
    ]
  },
  {
    path: '**', redirectTo: 'public'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
